import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import AppContext from '../../../contexts/AppContext';
import CircularNav from './CircularNav';
import Axl from '../../../utils/Axl';
import './MainBottomNav.css';

const MODES = {
  bts: 'bts-galleries',
  createMyOwn: 'create-my-own',
};

class MainBottomLayer extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.locationsManager = props.locManager;
    this.onClickHandler = this.onClickHandler.bind(this);

    this.pickLocationRef = React.createRef();

    this.state = {
      mode: null,
      showList: false,
      selectedCity: null,
    };
  }

  componentWillUnmount() {
    this.setState({
      selectedCity: null,
      showList: false,
    });
  }

  onClickHandler(item) {
    const { mode, selectedCity } = this.state;
    const { onLocationClickHandler, onCityClickHandler, onToggleMenu } =
      this.props;
    if (mode === MODES.createMyOwn) {
      if (selectedCity) {
        onToggleMenu();
        onCityClickHandler(item);
        this.setState({ showList: false });
        this.sendTrackEvent('view-location', item.name);
      } else {
        this.setState({ selectedCity: item });
        this.sendTrackEvent('view-city', item.city);
      }
    } else if (mode === MODES.bts) {
      onToggleMenu();
      onLocationClickHandler(item);
      this.setState({ showList: false });
    }
  }

  sendTrackEvent(action, label, value) {
    const { axl } = this.context;
    if (axl) {
      axl.sendMessage(Axl.ChildToHost.TRACK, {
        action,
        label,
        value,
      });
    }
  }

  createNewPanoHandler() {
    this.setState({
      mode: MODES.createMyOwn,
      selectedCity: null,
      showList: true,
    });
  }

  inspireMeHandler() {
    this.setState({
      mode: MODES.bts,
      selectedCity: null,
      showList: true,
    });
  }

  render() {
    const { dictionnary } = this.context;
    const {
      loadedGallery,
      locManager,
      onShareButtonHandler,
      isInEdition,
      onToggleMenu,
      btsMenuData,
      isShowingBottomNavHint,
      showMenu,
    } = this.props;
    const { showList, mode, selectedCity } = this.state;
    const btsGalleriesData = JSON.parse(JSON.stringify(btsMenuData));
    const locationsGalleriesData = selectedCity
      ? this.locationsManager.getByCity(selectedCity.city)
      : locManager.getCities();
    const BTS_BUTTON_ID = 'bts-home-button';
    const CREATE_BUTTON_ID = 'create-home-button';
    return (
      <>
        <div id="bts-menu">
          <CircularNav
            data={btsGalleriesData}
            isShown={showMenu && showList && mode === MODES.bts}
            buttonId={BTS_BUTTON_ID}
            onCloseHandler={() => {
              onToggleMenu();
              this.setState({ showList: false });
            }}
            onClickHandler={this.onClickHandler}
            currentGallery={loadedGallery}
          />
        </div>
        {!isMobile && (
          <div id="locations-menu">
            <CircularNav
              data={locationsGalleriesData}
              isShown={showMenu && showList && mode === MODES.createMyOwn}
              buttonId={CREATE_BUTTON_ID}
              selectedId={selectedCity ? selectedCity.city : null}
              isShowingBackButton={!!selectedCity}
              onCloseHandler={() => {
                if (!selectedCity) {
                  onToggleMenu();
                  this.setState({ showList: false });
                } else {
                  this.setState({ selectedCity: null });
                }
              }}
              onClickHandler={this.onClickHandler}
              currentGallery={loadedGallery}
            />
          </div>
        )}
        <button
          id="main-bottom-nav-share-button"
          type="button"
          className="main-button"
          onClick={() => {
            onShareButtonHandler();
          }}
        >
          {dictionnary.get(
            isInEdition
              ? 'main-bottom-nav-share-your-gallery'
              : 'main-bottom-nav-share',
          )}
        </button>
        {!isMobile && !isTablet && (
          <button
            id={CREATE_BUTTON_ID}
            type="button"
            className={`main-button main-bottom-button ${
              showMenu && showList && mode === MODES.createMyOwn ? 'selected' : ''
            }`}
            onClick={() => {
              onToggleMenu();
              this.createNewPanoHandler();
            }}
          >
            {dictionnary.get(
              isInEdition
                ? 'main-bottom-nav-create-new'
                : 'main-bottom-nav-create',
            )}
            <span>{dictionnary.get('main-bottom-nav-create-subtitle')}</span>
          </button>
        )}
        <button
          id={BTS_BUTTON_ID}
          type="button"
          className={`main-button main-bottom-button ${
            showMenu && showList && mode === MODES.bts ? 'selected' : ''
          } ${isShowingBottomNavHint ? 'pulsed' : ''}`}
          onClick={() => {
            onToggleMenu();
            this.inspireMeHandler();
          }}
        >
          {dictionnary.get('main-bottom-nav-bts')}
          <span>{dictionnary.get('main-bottom-nav-bts-subtitle')}</span>
        </button>
      </>
    );
  }
}

export default withRouter(MainBottomLayer);
